// extracted by mini-css-extract-plugin
export default {"textContainer":"Specification_textContainer__VCncA","textEffect":"Specification_textEffect__1JbhL"};